import { UPDATE_CHECKLIST, UPDATE_CHECKLIST_ITEM } from '../constants/actions';

export const updateChecklist = user => {
  return {
    type: UPDATE_CHECKLIST,
    user,
  };
};

export const updateChecklistItem = (item, value) => {
  return {
    type: UPDATE_CHECKLIST_ITEM,
    payload: { item, value },
  };
};
